// extracted by mini-css-extract-plugin
module.exports = {"closeButton":"dialog-close-button_closeButton__x4hDD"};